exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tab[data-v-550b46a7] {\n  background-color: transparent;\n  color: #484848;\n  border-radius: 8px 8px 0 0;\n  padding: 0 16px;\n  height: 40px;\n  border: 0;\n}\n.tab[disabled][data-v-550b46a7] {\n  background-color: rgba(100, 100, 100, 0.2);\n  color: rgba(100, 100, 100, 0.6);\n}\n.tab.active[data-v-550b46a7] {\n  background-color: #e9f1fb;\n  color: #085FCE;\n}", ""]);

// exports
